import {match} from 'ts-pattern';

import {CreatePromotionalPhotoRequestBody} from '@dms/api/shared';

import {hasPhotoLayer} from '../../CompositionEditor/utils/hasPhotoLayer';
import {PromoPhotosFormType} from '../types/PromoPhotosFormType';
import {getPromoPhotoVehicleSelection} from './getPromoPhotoVehicleSelection';

const DEFAULT_SOURCE_PHOTO_INDEX = 1;

// The BE validates the shape per `type`: a REGULAR photo carries only `fileId` and its vehicle
// selection, a FINANCING one only the product, source photo index and composition. The other
// group is sent as null. The source photo index only matters for a composition with a photo slot;
// without one it is sent as null. `autoAssign` and `vehicleSelection` are sent for both types: PUT
// resets an omitted `autoAssign` to false and clears an omitted selection.
export const getPromoPhotoRequestData = (
  data: PromoPhotosFormType
): CreatePromotionalPhotoRequestBody =>
  match(data.type)
    .with('REGULAR', () => ({
      type: 'REGULAR' as const,
      title: data.title,
      position: data.position,
      fileId: data.fileId?.id ?? null,
      financialProductType: null,
      sourcePhotoIndex: null,
      composition: null,
      vehicleSelection: getPromoPhotoVehicleSelection(data),
      autoAssign: data.autoAssign,
    }))
    .with('FINANCING', () => ({
      type: 'FINANCING' as const,
      title: data.title,
      position: data.position,
      fileId: null,
      financialProductType: data.financialProductType,
      sourcePhotoIndex: hasPhotoLayer(data.composition?.layers ?? [])
        ? (data.sourcePhotoIndex ?? DEFAULT_SOURCE_PHOTO_INDEX)
        : null,
      composition: data.composition,
      vehicleSelection: null,
      autoAssign: data.autoAssign,
    }))
    .exhaustive();
